var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFutsal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 134.9,
    width: 144,
    height: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3,113.3c3.5,0,6.3,2.8,6.3,6.3c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3C49,116.1,51.8,113.3,55.3,113.3  M55.3,110.6c-5,0-9,4-9,9c0,5,4,9,9,9s9-4,9-9C64.3,114.6,60.2,110.6,55.3,110.6L55.3,110.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.2,96.2l25.4-25.4l-7.3-7.3L22,88.9c-2,2-2,5.3,0,7.3C24,98.2,27.2,98.2,29.2,96.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5,72.5L9.2,119.8c-2,2-2,5.3,0,7.3c2,2,5.3,2,7.3,0l47.2-47.2L56.5,72.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6,32.1c2.5,0,4.7-1,6.4-2.6c1.6-1.6,2.6-3.9,2.6-6.4s-1-4.7-2.6-6.4c-1.6-1.6-3.9-2.6-6.4-2.6c-2.5,0-4.7,1-6.4,2.6 c-1.6,1.6-2.6,3.9-2.6,6.4s1,4.7,2.6,6.4S81.1,32.1,83.6,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.2,36H49.5c-1.3,0-2.6,0.5-3.6,1.5L31.4,52c-2,2-2,5.3,0,7.3c2,2,5.3,2,7.3,0l13-13h12.9L51,59.8l16.3,16.4l29.9-29.9 h33.9c2.8,0,5.1-2.3,5.1-5.1S134,36,131.2,36z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFutsal);
export default __webpack_public_path__ + "static/media/futsal.c7971856ea696a158aaa5b0bd49af7f7.svg";
export { ForwardRef as ReactComponent };